// extracted by mini-css-extract-plugin
module.exports = {"layout":"CarType_layout__qtyWs","carTypes":"CarType_carTypes__2yhpF","carType":"CarType_carType__XXN4N","image":"CarType_image__ZYBtU","carTypeTitle":"CarType_carTypeTitle__qekIq"};